export const setRemainingAttempts = (payload) => {
    return { type: 'SET_REMAINING_ATTEMPTS', payload };
};

export const setFailAttemptBanner = (payload) => {
    return { type: 'SET_FAIL_ATTEMPT_BANNER', payload };
};

export const setLockedOut = (payload) => {
    return { type: 'SET_LOCKED_OUT', payload };
};

export const setIncompleteEntry = (payload) => {
    return { type: 'SET_INCOMPLETE_ENTRY', payload };
};

export const setLockoutTime = (payload) => {
    return { type: 'SET_LOCKOUT_TIME', payload };
};

export const setFutureTimestamp = (payload) => {
    return { type: 'SET_FUTURE_TIMESTAMP', payload };
};

export const setCallingVerify = (payload) => {
    return { type: 'SET_CALLING_VERIFY', payload };
};

export const setUnhandledErrorState = (payload) => {
    return { type: 'SET_UNHANDLED_ERROR_STATE', payload };
};

export const setShowSplash = (payload) => {
    return { type: 'SET_SHOW_SPLASH', payload };
};
